import { render, staticRenderFns } from "./RegionHeader.vue?vue&type=template&id=e4d67a4a&scoped=true&"
import script from "./RegionHeader.vue?vue&type=script&lang=js&"
export * from "./RegionHeader.vue?vue&type=script&lang=js&"
import style0 from "./RegionHeader.vue?vue&type=style&index=0&id=e4d67a4a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4d67a4a",
  null
  
)

export default component.exports